import type { ColumnsType } from 'antd/es/table'
import type { MouseEvent } from 'react'

const stopPropagationHandlers = {
  onClick: (e: MouseEvent<HTMLElement>) => e.stopPropagation(),
  onMouseDown: (e: MouseEvent<HTMLElement>) => e.stopPropagation(),
  onPointerDown: (e: MouseEvent<HTMLElement>) => e.stopPropagation()
}

const actionKeys = ['actions', 'action']

export const hasChildrenColumns = <T>(
  col: ColumnsType<T>[number]
): col is ColumnsType<T>[number] & { children: ColumnsType<T> } =>
  'children' in col && Array.isArray(col.children)

export const enhanceColumns = <T>(cols: ColumnsType<T>): ColumnsType<T> =>
  cols?.map((col) => {
    const isActionsColumn =
      'key' in col && actionKeys?.includes(col.key as string)

    return {
      ...col,
      ...(isActionsColumn && { onCell: () => stopPropagationHandlers })
    }
  })
